export const modelingCategorySlugDetectSingleSearchEnding = '_single';
